import { masterAPIClient } from '@/clients/MasterAPIClient';
import { IOptions } from '@/data/models/option';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

export const getReleaseTypesQueryKey = 'release-types' as const;

export default function useGetReleaseTypesQuery(): UseQueryResult<
  IOptions[],
  Error
> {
  async function queryFn() {
    const response = await masterAPIClient.getReleaseTypes();
    return response;
  }

  return useQuery({
    queryFn,
    queryKey: [getReleaseTypesQueryKey],
    staleTime: Infinity,
  });
}
